import {Component, forwardRef, Input} from '@angular/core';
import {BaseControlDirective} from '../../directives/base-control.directive';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SwitcherComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => SwitcherComponent), multi: true }
  ],
})
export class SwitcherComponent extends BaseControlDirective {
  @Input() id: string;
}
